import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MapWorkspacesStoreService } from 'src/app/shared/common/current-map-workspaces/map-workspaces-store.service';
import { ProjectStreamService } from 'src/app/shared/common/current-project/project-stream.service';
import { WorkspaceType } from 'src/app/shared/map-data-services/mapWorkspace/map-workspace.types';
import { HEADER_WORKSPACE_TYPE } from '../authentication/share-token';

@Component({
    selector: 'load-survey-viewer',
    template: `
        <div class="container">
            <div class="app-loading" *ngIf="loading"></div>
        </div>
    `
})
export class LoadSurveyViewerComponent implements OnInit {
    public projectId: string = null;
    public region: string = null;
    public loading = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private projectStream: ProjectStreamService,
        private mapWorkspacesStore: MapWorkspacesStoreService
    ) {}

    public ngOnInit(): void {
        this.projectId = this.activatedRoute.snapshot.params.projectId || null;
        this.region = this.activatedRoute.snapshot.queryParams.region || null;
        this.loading = true;

        this.projectStream.initCurrentProject(this.projectId).then(project => {
            this.mapWorkspacesStore
                .getDefaultOrCreateMapWorkspace(project.id, WorkspaceType.SURVEY, project.isChanged)
                .then(workspace => {
                    // Store workspace type for HTTP interceptor to add to request headers - see http-interceptor.service.ts
                    sessionStorage.setItem(HEADER_WORKSPACE_TYPE, workspace.type);

                    this.router.navigate(['mapViewer'], {
                        queryParams: {
                            projectId: workspace.projectId,
                            workspaceId: workspace.id,
                            region: this.region
                        }
                    });
                });
        });
    }
}
